module.exports = __webpack_public_path__ + "img/d2.0ef09ea0.png";